webpackJsonp([109808387336812],{

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(29);
	
	var _filterSort = __webpack_require__(40);
	
	var _filterSort2 = _interopRequireDefault(_filterSort);
	
	var _stateProvider = __webpack_require__(16);
	
	var _stateProvider2 = _interopRequireDefault(_stateProvider);
	
	var _globalState = __webpack_require__(6);
	
	var _globalState2 = _interopRequireDefault(_globalState);
	
	var _stringTranslation = __webpack_require__(13);
	
	var _headerFilterSortModule = __webpack_require__(22);
	
	var _headerFilterSortModule2 = _interopRequireDefault(_headerFilterSortModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var container = _headerFilterSortModule2.default.container,
	    list = _headerFilterSortModule2.default.list;
	
	var ArticleFilterSort = function (_FilterSort) {
	  _inherits(ArticleFilterSort, _FilterSort);
	
	  function ArticleFilterSort() {
	    _classCallCheck(this, ArticleFilterSort);
	
	    return _possibleConstructorReturn(this, _FilterSort.apply(this, arguments));
	  }
	
	  ArticleFilterSort.prototype.queriesToGlobalState = function queriesToGlobalState() {
	    return {
	      filter: 'articleFilter',
	      sort: 'articleSort',
	      archive: 'articleArchive'
	    };
	  };
	
	  ArticleFilterSort.prototype.renderContent = function renderContent() {
	    var _this2 = this;
	
	    var _parseQuery = (0, _filterSort.parseQuery)(this.props.location.search, {
	      filter: null,
	      sort: null,
	      archive: null
	    }),
	        sort = _parseQuery.sort,
	        filter = _parseQuery.filter,
	        archive = _parseQuery.archive;
	
	    var filterOptions = [{
	      label: (0, _stringTranslation.translate)('all'),
	      value: null
	    }].concat(_globalState2.default.state.articleCategories.filter(function (category) {
	      return category.lang === _this2.props.language;
	    }).map(function (category) {
	      return {
	        label: category.label,
	        value: category.slug
	      };
	    }));
	
	    var sortOptions = [{
	      label: (0, _stringTranslation.translate)('newest'),
	      value: null
	    }, {
	      label: (0, _stringTranslation.translate)('oldest'),
	      value: 'oldest'
	    }, {
	      label: (0, _stringTranslation.translate)('most_popular'),
	      value: 'most-popular'
	    }];
	
	    return _react2.default.createElement(
	      'div',
	      { className: container },
	      _react2.default.createElement(
	        'ul',
	        { className: list },
	        this.renderOptions(filterOptions, filter, 'articleFilter', 'filter')
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: list },
	        this.renderOptions(sortOptions, sort, 'articleSort', 'sort')
	      )
	    );
	  };
	
	  return ArticleFilterSort;
	}(_filterSort2.default);
	
	exports.default = (0, _stateProvider2.default)((0, _reactRouter.withRouter)(ArticleFilterSort), function (state) {
	  return {
	    filter: state.articleFilter,
	    sort: state.articleSort,
	    archive: state.articleArchive,
	    language: state.language
	  };
	});
	module.exports = exports['default'];

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.parseQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(29);
	
	var _globalState = __webpack_require__(6);
	
	var _globalState2 = _interopRequireDefault(_globalState);
	
	var _filterSort = __webpack_require__(57);
	
	var _headerFilterSortModule = __webpack_require__(22);
	
	var _headerFilterSortModule2 = _interopRequireDefault(_headerFilterSortModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var container = _headerFilterSortModule2.default.container,
	    list = _headerFilterSortModule2.default.list,
	    item = _headerFilterSortModule2.default.item,
	    itemActive = _headerFilterSortModule2.default.itemActive;
	
	var FilterSort = function (_React$PureComponent) {
	  _inherits(FilterSort, _React$PureComponent);
	
	  function FilterSort(props) {
	    _classCallCheck(this, FilterSort);
	
	    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));
	
	    _this.listenHistory = _this.listenHistory.bind(_this);
	    _this.queriesToGlobalStateMap = _this.queriesToGlobalState();
	    return _this;
	  }
	
	  FilterSort.prototype.renderOptions = function renderOptions(options, current, stateKey, propKey) {
	    var _this2 = this;
	
	    var qArgs = {};
	    for (var key in this.queriesToGlobalStateMap) {
	      qArgs[key] = this.props[key];
	    }
	
	    return options.map(function (option) {
	      return _react2.default.createElement(
	        'li',
	        {
	          key: option.value,
	          className: current === option.value ? itemActive : item,
	          onClick: function onClick() {
	            var _extends2;
	
	            var q = (0, _filterSort.buildQuery)(_extends({}, qArgs, (_extends2 = {}, _extends2[propKey] = option.value, _extends2)), true);
	
	            if (option.value !== current) {
	              var _globalState$setState;
	
	              window.___gatsbyNavigateTo('' + _this2.props.location.pathname + q);
	
	              _globalState2.default.setState((_globalState$setState = {}, _globalState$setState[stateKey] = option.value, _globalState$setState));
	            }
	          }
	        },
	        option.label
	      );
	    });
	  };
	
	  FilterSort.prototype.componentDidMount = function componentDidMount() {
	    this.setGlobalStateFromPath(this.props.location.search);
	    this.unlistenHistory = this.props.history.listen(this.listenHistory);
	  };
	
	  FilterSort.prototype.listenHistory = function listenHistory(location) {
	    this.setGlobalStateFromPath(location.search);
	  };
	
	  FilterSort.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unlistenHistory();
	  };
	
	  FilterSort.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    this.setGlobalStateFromPath(nextProps.location.search);
	  };
	
	  FilterSort.prototype.setGlobalStateFromPath = function setGlobalStateFromPath(getQuery) {
	    var initial = {};
	    for (var key in this.queriesToGlobalStateMap) {
	      initial[key] = null;
	    }
	    var newQuery = (0, _filterSort.parseQuery)(getQuery, initial);
	
	    var changed = false;
	    var newState = {};
	    for (var _key in this.queriesToGlobalStateMap) {
	      var globalKey = this.queriesToGlobalStateMap[_key];
	
	      if (_globalState2.default.state[globalKey] !== newQuery[_key]) {
	        changed = true;
	      }
	
	      newState[globalKey] = newQuery[_key];
	    }
	
	    if (changed) {
	      _globalState2.default.setState(newState);
	    }
	  };
	
	  FilterSort.prototype.renderContent = function renderContent() {
	    return null;
	  };
	
	  FilterSort.prototype.render = function render() {
	    var _props$inHeader = this.props.inHeader,
	        inHeader = _props$inHeader === undefined ? true : _props$inHeader;
	
	
	    if (!inHeader) {
	      return _react2.default.createElement(
	        'div',
	        { className: _headerFilterSortModule2.default.notInHeader },
	        this.renderContent()
	      );
	    } else {
	      return this.renderContent();
	    }
	  };
	
	  return FilterSort;
	}(_react2.default.PureComponent);
	
	exports.default = FilterSort;
	exports.parseQuery = _filterSort.parseQuery;

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _stateProvider = __webpack_require__(16);
	
	var _stateProvider2 = _interopRequireDefault(_stateProvider);
	
	var _headerSpacer = __webpack_require__(20);
	
	var _headerSpacer2 = _interopRequireDefault(_headerSpacer);
	
	var _articleFilterSort = __webpack_require__(112);
	
	var _articleFilterSort2 = _interopRequireDefault(_articleFilterSort);
	
	var _excerptList = __webpack_require__(76);
	
	var _excerptList2 = _interopRequireDefault(_excerptList);
	
	var _excerpt = __webpack_require__(75);
	
	var _excerpt2 = _interopRequireDefault(_excerpt);
	
	var _navigation = __webpack_require__(24);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _globalState = __webpack_require__(6);
	
	var _globalState2 = _interopRequireDefault(_globalState);
	
	var _linkBuilder = __webpack_require__(21);
	
	var _linkBuilder2 = _interopRequireDefault(_linkBuilder);
	
	var _filterSort = __webpack_require__(57);
	
	var _stringTranslation = __webpack_require__(13);
	
	var _postModule = __webpack_require__(88);
	
	var _postModule2 = _interopRequireDefault(_postModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var postTileContainer = _postModule2.default.postTileContainer,
	    postSingleSeeMore = _postModule2.default.postSingleSeeMore;
	
	
	var getSortFn = function getSortFn(sortBy) {
	  switch (sortBy) {
	    case 'oldest':
	      return function (a, b) {
	        return a.dateObj - b.dateObj;
	      };
	    case 'most-popular':
	      return function (a, b) {
	        return b.popularity - a.popularity;
	      };
	    case null:
	      return function (a, b) {
	        return b.dateObj - a.dateObj;
	      };
	    case 'default':
	      return 0;
	  }
	};
	
	var ArticlesArchive = function (_React$PureComponent) {
	  _inherits(ArticlesArchive, _React$PureComponent);
	
	  function ArticlesArchive(props) {
	    _classCallCheck(this, ArticlesArchive);
	
	    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));
	
	    _this.state = {
	      showText: true
	    };
	
	    _this.articles = _this.props.data && _this.props.data.articles ? _this.props.data.articles.edges.map(function (edge) {
	      return _extends({}, edge.node, {
	        dateObj: new Date(edge.node.date)
	      });
	    }) : [];
	    return _this;
	  }
	
	  ArticlesArchive.prototype.onMountGlobalState = function onMountGlobalState(state) {
	    return _extends({}, state, {
	      whiteLogo: false
	    });
	  };
	
	  ArticlesArchive.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        sort = _props.sort,
	        filter = _props.filter,
	        archive = _props.archive,
	        windowWide = _props.windowWide;
	
	
	    var articles = this.articles.filter(function (article) {
	      return (filter === null || article.categories.filter(function (cat) {
	        return cat.slug === filter;
	      }).length > 0) && (archive === null || article.fields.date_archive === archive);
	    }).sort(getSortFn(sort));
	
	    var archiveHeader = null;
	
	    if (archive) {
	      var _archive$split = archive.split('-'),
	          year = _archive$split[0],
	          month = _archive$split[1];
	
	      archiveHeader = _react2.default.createElement(
	        'div',
	        { className: postSingleSeeMore },
	        (0, _stringTranslation.translate)('months')[parseInt(month, 10) - 1] + ' ' + year
	      );
	    }
	    // windowWidth > 1200
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_headerSpacer2.default, null),
	      !windowWide && _react2.default.createElement(_articleFilterSort2.default, { inHeader: false }),
	      archiveHeader,
	      _react2.default.createElement(
	        _excerptList2.default,
	        {
	          flip: true,
	          onFlipStart: function onFlipStart() {
	            _this2.setState({ showText: false });
	          },
	          onFlipFinish: function onFlipFinish() {
	            _this2.setState({ showText: true });
	          },
	          className: postTileContainer
	        },
	        articles.map(function (article, index) {
	          return _react2.default.createElement(_excerpt2.default, {
	            data: article,
	            featured: index === 0,
	            key: article.slug,
	            showText: _this2.state.showText
	          });
	        })
	      ),
	      _react2.default.createElement(_navigation2.default, null)
	    );
	  };
	
	  return ArticlesArchive;
	}(_react2.default.PureComponent);
	
	exports.default = (0, _stateProvider2.default)(ArticlesArchive, function (state) {
	  return {
	    filter: state.articleFilter,
	    sort: state.articleSort,
	    archive: state.articleArchive,
	    windowWide: state.windowWidth > 1200
	  };
	});
	module.exports = exports['default'];

/***/ }),

/***/ 22:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"notInHeader":"src-styles-components----headerFilterSort-module---notInHeader---1bvWw","container":"src-styles-components----headerFilterSort-module---container---1OZuO","list":"src-styles-components----headerFilterSort-module---list---2Kylf","item":"src-styles-components----headerFilterSort-module---item---2Dx6H","itemActive":"src-styles-components----headerFilterSort-module---itemActive---3cT3f src-styles-components----headerFilterSort-module---item---2Dx6H"};

/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _page = __webpack_require__(17);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _stringTranslation = __webpack_require__(13);
	
	var _seo = __webpack_require__(32);
	
	var _seo2 = _interopRequireDefault(_seo);
	
	var _archive = __webpack_require__(241);
	
	var _archive2 = _interopRequireDefault(_archive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArticleArchivePost = function (_Page) {
	  _inherits(ArticleArchivePost, _Page);
	
	  function ArticleArchivePost() {
	    _classCallCheck(this, ArticleArchivePost);
	
	    return _possibleConstructorReturn(this, _Page.apply(this, arguments));
	  }
	
	  ArticleArchivePost.prototype.onMountGlobalState = function onMountGlobalState(state) {
	    return _extends({}, state, {
	      whiteLogo: false,
	      headerWidget: 'articleFilterSort'
	    });
	  };
	
	  ArticleArchivePost.prototype.render = function render() {
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_seo2.default, _extends({
	        title: (0, _stringTranslation.translate)('articles')
	      }, this.props.pathContext, {
	        key: 'seo'
	      })),
	      _react2.default.createElement(_archive2.default, { data: this.props.data })
	    );
	  };
	
	  return ArticleArchivePost;
	}(_page2.default);
	
	exports.default = ArticleArchivePost;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-blog-archive-js-d86b462b255ce5896869.js